import React, { ChangeEvent, useState } from 'react';
import cx from 'classnames';
import { useFormContext } from 'react-hook-form';

type RadioProps = JSX.IntrinsicElements['input'] & {
  id: string;
  children?: React.ReactNode;
  widthFull?: boolean;
  onChange?(
    event: ChangeEvent<HTMLInputElement>,
    value: RadioProps['value'],
  ): void;
};
type RadioStatus = 'focused' | 'idle';

const Radio: React.FC<RadioProps> = ({
  checked,
  children,
  id,
  name,
  value,
  widthFull,

  onChange,
  ...rest
}) => {
  const { register } = useFormContext() || {};
  const [status, setStatus] = useState<RadioStatus>('idle');

  const wrapperClassNames = cx(
    'radio--wrapper border-2 rounded-lg flex items-center min-h-10 py-3 px-2 leading-tight cursor-pointer relative bg-white transition duration-150',
    {
      'radio--wrapper--labeled border-tim-primary text-tim-primary': checked,
      'border-gray-500 text-gray-600 hover:bg-gray-100 active:bg-gray-200':
        !checked,
      'radio--wrapper--focused': status === 'focused',
      'w-full my-2': widthFull,
      'flex-1': !widthFull,
    },
  );

  return (
    <label htmlFor={id} className={wrapperClassNames}>
      <input
        {...rest}
        {...register(name!!)}
        name={name}
        className='radio--input absolute -z-1 ml-2 mr-4 opacity-0'
        id={id}
        value={value}
        type='radio'
        checked={checked}
        onChange={(e) => onChange?.(e, value)}
        onFocus={() => setStatus('focused')}
        onBlur={() => setStatus('idle')}
      />
      <span className='radio--checkmark min-h-5 min-w-5 relative ml-2 h-5 w-5' />
      <div className='radio--label relative flex items-center pl-4'>
        {children}
      </div>
    </label>
  );
};

export default Radio;
